/**
 * Application class
 * @param {String} name
 */

import 'animation.gsap';
import 'gsap/ScrollToPlugin';
import Vue from 'vue';
import $ from 'jquery';
import globalUtils from './global-utils';
import PrizesItem from './components/prizes-item';
import TgeItem from './components/tge-item';
import FormItem from './components/form-item.vue';
import formProject from './components/form-project.vue';
import FormArtistic from './components/form-artistic.vue';
import formBudget from './components/form-budget.vue';
import formPrize from './components/form-prize.vue';
import formAuthorization from './components/form-authorization.vue';
import formLeadcompany from './components/form-leadcompany.vue';
import flipbookItem from './components/flipbook-item.vue';
import videoYoutube from './components/video-youtube.vue';
// import stripeForm from './components/stripe-form.vue';
import { TweenLite, TweenMax, Power2, Back } from 'gsap';

export default class Application {
    /**
     * App private props
     */
    name;
    instance;

    constructor (name, rollbarInstance) {
        console.info('%s: create app', name);

        this.name = name;
        this.rollbarInstance = rollbarInstance;
        this.instance = this.createVueInstance();
    }

    createVueInstance () {
        console.info('%s: create main vue instance', this.name, this.rollbarInstance);

        // Assign vue error handler a rollbar log
        Vue.config.errorHandler = (error) => {
            console.error(error);

            if (this.rollbarInstance) {
                this.rollbarInstance.error(error);
            }
        };

        const view = new Vue(
            {
                /**
                 * Attach vue to DOM element
                 */
                el: '#fedora',

                /**
                 * Set component name
                 */
                name: this.name.toLowerCase(),

                /**
                 * Child components
                 * @type {Object}
                 */
                components: {
                    PrizesItem,
                    TgeItem,
                    FormItem,
                    formProject,
                    FormArtistic,
                    formBudget,
                    formAuthorization,
                    formPrize,
                    videoYoutube,
                    formLeadcompany,
                    flipbookItem
                    // stripeForm
                },

                /**
                 * Component data
                 * @return {Object}
                 */
                data () {
                    const dataObject = {
                        currentVideo: false,
                        currentVideoReady: false,
                        joinUsTab: 1,
                        stripeToken: ''
                    };

                    return dataObject;
                },

                /**
                 * Component created event handler
                 * @return {Void}
                 */
                created () { },

                /**
                 * Component mounted event handler
                 * @return {Void}
                 */
                mounted () {
                    const body = document.body;
                    const userAgent = navigator.userAgent;

                    if (body instanceof HTMLElement) {
                        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
                            body.classList.add('mobile-app');
                        } else {
                            body.classList.add('desktop-app');
                        }
                    }

                    /*
                    * CSRF Security handle error handles
                    */
                    $.ajaxSetup({ headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') } });
                    $(document).ajaxError(function (event, xhr) {
                        if (xhr.status === 419) {
                            $('body').removeClass(globalUtils.formatedPopupClasses());
                            $('body').addClass('popup-open popup-refresh-open');
                        }
                    });

                    // Initialize global utils
                    globalUtils.initialize();
                    window.isInitializedRecaptcha = 0;
                    window.sendingForm = false;
                    window.onValidForm = globalUtils.onValidForm;

                    /* inject formatedPopupClasses */
                    let popupClasses = globalUtils.popupClasses;

                    window.submitRegister = globalUtils.submitRegister;
                    window.formatedPopupClasses = popupClasses.join(' ');

                    this.initCarouselSliders();
                    if ($('body').hasClass('join-us')) {
                        this.initializeJoinUs();
                    }
                },

                /**
                 * Component updated event handler
                 * @return {Void}
                 */
                updated () { },

                /**
                 * Component methods
                 * @type {Object}
                 */
                methods: {
                    playYoutube (video) {
                        const base = this;

                        TweenMax.to(
                            $('.overlay--standard'),
                            0.5,
                            {
                                autoAlpha: 1,
                                ease: Power2.easeInOut,
                                onCompleteScope: this,
                                onComplete () {
                                    if (!this.currentVideo && window.YT && window.YT.Player) {
                                        let player = $('#video-youtube').append('<div id="player">');

                                        this.currentVideo = new window.YT.Player(
                                            'player', {
                                                videoId: video,
                                                playerlets: {
                                                    autoplay: 1,
                                                    controls: 0,
                                                    showinfo: 0,
                                                    modestbranding: 1,
                                                    loop: 1,
                                                    fs: 0,
                                                    cc_load_policy: 0,
                                                    iv_load_policy: 3,
                                                    autohide: 0
                                                },
                                                events: {
                                                    onReady: (event) => {
                                                        base.currentVideoReady = true;
                                                        if (parseInt(player.parent().parent()
                                                            .css('opacity')) === 1) {
                                                            event.target.playVideo();
                                                        } else {
                                                            event.target.stopVideo();
                                                            event.target.clearVideo();
                                                        }
                                                    }
                                                }
                                            }
                                        );
                                    } else {
                                        if (this.currentVideo.getVideoData().video_id !== video) {
                                            this.currentVideo.loadVideoById(video);
                                        }
                                        this.currentVideo.seekTo(0);
                                        this.currentVideo.playVideo();
                                    }
                                }
                            }
                        );
                    },

                    hideOverlay () {
                        if (this.currentVideoReady && this.currentVideo) {
                            this.currentVideo.stopVideo();
                            this.currentVideo.clearVideo();
                        }

                        TweenMax.to(
                            $('.overlay--standard'),
                            0.5,
                            {
                                autoAlpha: 0,
                                ease: Power2.easeInOut
                            }
                        );
                    },

                    initCarouselSliders () {
                        $('.testimonies--carousel--outer').each(
                            function () {
                                let owlConfig = {
                                    items: 1,
                                    nav: true,
                                    dots: true,
                                    navText: ['<i class="fedoraicon fi-chevron-left"></i>', '<i class="fedoraicon fi-chevron-right"></i>'],
                                    navContainer: $('.testimonies--carousel--nav', this),
                                    responsive: {
                                        0: { items: 1 },
                                        1024: { items: 2 }
                                    }
                                };

                                if ($(this).hasClass('testimonies-home')) {
                                    owlConfig.dots = false;
                                }

                                $('.testimonies--carousel', this).owlCarousel(owlConfig);
                            }
                        );
                    },

                    refreshCarouselSliders () {
                        const base = this;

                        $('.testimonies--carousel--outer').each(
                            function () {
                                const $owl = $('.testimonies--carousel', this);

                                $owl.trigger('destroy.owl.carousel');
                            }
                        );

                        // ¯\_(ツ)_/¯
                        let owlInterval = setInterval(function () {
                            base.initCarouselSliders();
                            clearInterval(owlInterval);
                        }, 500);
                    },

                    switchJoinUsTab (id) {
                        const element = document.getElementById('join-us-' + id);

                        this.joinUsTab = id;

                        TweenLite.to(
                            window,
                            0.5,
                            {
                                scrollTo: {
                                    y: element,
                                    offsetY: 90,
                                    autoKill: false
                                },
                                delay: 0.25,
                                ease: Back.easeOut.config(0.8)
                            }
                        );

                        this.refreshCarouselSliders();
                    },

                    initializeJoinUs () {
                        if (window.location.hash) {
                            if (window.location.hash === '#organisational') {
                                this.switchJoinUsTab(1);
                            } else if (window.location.hash === '#individual') {
                                this.switchJoinUsTab(2);
                            } else if (window.location.hash === '#corporate') {
                                this.switchJoinUsTab(3);
                            }
                        }
                    }
                }
            }
        );

        return view;
    }
}
